import React, {createRef, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
// import SplashScreen from 'react-native-splash-screen';
// import NetInfo from '@react-native-community/netinfo';
import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import {Donate} from './screens/main';
import {Rules} from './screens/main/donate/rules';
import * as actions from '@actions';
// import 'dotenv/config';
// import queryString from 'query-string';
// import { instance } from './store/api';
import {initializeApp} from 'firebase/app';
import {getAuth, onAuthStateChanged} from 'firebase/auth';
import {initializeParse} from "@parse/react";
import {getTrial} from "./lib/getTrial";
import {debounce} from "lodash";
import {Noti} from "./components/atoms";

/*const firebaseConfig = {
    apiKey: 'AIzaSyD8jXGcxCIeG6xLaezF2FcOtHcdjk2eBg0',
    authDomain: 'insaqu-39479.firebaseapp.com',
    projectId: 'insaqu-39479',
    storageBucket: 'insaqu-39479.appspot.com',
    messagingSenderId: '603068236957',
    appId: '1:603068236957:web:b41bd4d08d144ff59b4074',
    measurementId: 'G-DE7D1Y8LW6',
};

initializeApp(firebaseConfig);
global.auth = getAuth(); */

console.log('process:', process.env.SERVER_URL);
initializeParse(process.env.SERVER_URL, process.env.APPLICATION_ID, process.env.API_KEY);

const Stack = createStackNavigator();
const {Navigator, Screen} = Stack;

const navigationRef = createRef();

const App = ({/*setUserData, hasUid*/}) => {
    /*const [user, setUser] = useState(null);
    const [notiTitle, setNotiTitle] = useState('sadasdasd');*/

    /*function onStateChanged(user) {
        // console.log('user->', user);
        setUserData(user);
    }*/

    /*const onStateChanged = debounce((newUser) => {
        // setUser(user);
        // console.log('user->', newUser);
        newUser?.uid && setUser(newUser);
        setUserData(newUser);
    }, 200);

    useEffect(() => {
        console.log('user:', user);
        if (user?.uid) {
            getTrial(user, setNotiTitle);
        }
    }, [user]);

    useEffect(() => {
        // подписка на изменение юзера
        const unsubscriber = onAuthStateChanged(auth, onStateChanged);
        return unsubscriber;
    }, []);*/


    return (<NavigationContainer
        linking={{
            //prefixes: ['http://dev.viacheslav.keenetic.link', 'localhost'],
            config: {
                screens: {
                    Donate: 'payment',
                    Rules: 'rules',
                    /*SignIn: 'signin',
                    SignUp: 'signup',
                    FirstScreen: 'firstScreen',
                    ResetPassword: 'resetpassword',
                    DeleteAccount: 'delete-account',
                    Main: {
                        screens: {
                            MainMenu: 'mainmenu',
                            TestStackScreen: 'test',
                            Profile: 'profile',
                            FavouritesStackScreen: {
                                screens: {Favourites: 'favourites'},
                            },
                        },
                    },*/
                },
            },
        }}
        ref={navigationRef}
    >
        <Navigator headerMode="screen" screenOptions={{
            headerShown: false,
        }}>
            <Screen name="Payment" component={Donate}/>
            <Screen name="Rules" component={Rules}/>
        </Navigator>
        {/*!!notiTitle && <Noti title={notiTitle}/>*/}
    </NavigationContainer>);
};


export default App;
